<script lang="ts">
	import { createEventDispatcher } from "svelte";
	import { currentItemId, variantsStore } from "../scripts/stores";
	import { Loader } from "../../generic/components";
	import { isNullish, formatPrice } from "../../generic/scripts/functions";
	import { msg } from "../scripts/getters";
	import InvalidParams from "./InvalidParams.svelte";

	const dispatch = createEventDispatcher();
	export let invalidParams: [string, string][] = [];

	$: showSubitems = !isNullish($variantsStore) && $variantsStore.size > 0 && !isNullish($currentItemId);
</script>

{#if showSubitems}
	<InvalidParams alertType="warning" title={msg("variant.notFound")} {invalidParams} />
	<div class="subitems">
		{#each [...$variantsStore] as [_, variant] (variant.id)}
			{@const { data: subitem } = variant}
			{@const checked = $currentItemId === variant.id}
			<label for="in_{variant.id}" class="subitem" class:activeValue={checked} id={variant.id.toString()} data-variant-subitem-symbol={subitem.symbol}>
				<div class="custom-control custom-radio form-check-inline">
					<input id="in_{variant.id}" class="form-check-input" {checked} type="radio" name="subitems" value={subitem.symbol} on:change|preventDefault={() => dispatch("change", variant.id)} />
				</div>
				<img src={subitem.image} class="img-fluid subitemImg" alt={subitem.name} />
				<div class="subitemName">{subitem.name}</div>
				{#if !isNullish(subitem.priceGross)}
					<div class="subitemPrice">
						{formatPrice(subitem.priceGross)}
					</div>
				{/if}
			</label>
		{/each}
	</div>
{:else}
	<Loader outDelay={300} />
{/if}
